export var CONSTANT = '_Constant';
var constant = {
    regex: /\d+/,
    typeConstant: CONSTANT,
    tokenize: function (raw) { return parseInt(raw); },
    roll: function () { return []; },
    calculateValue: function (token) { return token; },
};
export default constant;
